import moment from 'moment'
import { Clock } from 'lucide-vue-next'

export const isExpired = (link) => !!link.expires_at && new Date(link.expires_at) < new Date()
export const isExhausted = (link) => !!link.max_uses && link.joined.length >= link.max_uses

export const expiryLabel = (link) => {
  if (!link.expires_at) return 'Never expires'
  return isExpired(link) ? 'Expired' : `Expires ${moment(link.expires_at).format('D MMM, HH:mm')}`
}

// Time left as "45m", "3h" or "6d"; the exact date lives in the tooltip.
export const timeLeftLabel = (link) => {
  if (isExpired(link)) return 'Expired'
  const minutes = Math.max(1, Math.round((new Date(link.expires_at) - Date.now()) / 60000))
  if (minutes < 60) return `${minutes}m`
  if (minutes < 1440) return `${Math.round(minutes / 60)}h`
  return `${Math.round(minutes / 1440)}d`
}

export const usesLabel = (link) =>
  link.max_uses ? `${link.joined.length}/${link.max_uses} uses` : 'Unlimited uses'

// Only limits that are actually set are shown; `warn` marks the one that currently blocks joining.
export const limitItems = (link) =>
  [
    link.max_uses ? { key: 'uses', label: `${link.joined.length}/${link.max_uses}`, text: usesLabel(link), warn: isExhausted(link) } : null,
    link.expires_at ? { key: 'expiry', icon: Clock, label: timeLeftLabel(link), text: expiryLabel(link), warn: isExpired(link) } : null,
  ].filter(Boolean)
